import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const getNotifications = createAsyncThunk("notifications/get", async (values, { rejectWithValue }) => makeRequest("/notifications", "GET", values, rejectWithValue));
